import { useState } from "react";
import DeviceManagementService from "../services/api/device-management-service"
import GateService from "../services/api/gate-service";
import { useSnackbar } from "notistack";


export const useGate = () => {


    const [gateList, setGateList] = useState([]);
    const [loading, setLoading] = useState(false);
    const {enqueueSnackbar} = useSnackbar();

    const gateFilterList = (parameters) => {
        setLoading(true)
        GateService.gateFilterList(parameters).then((res)=>{
            console.log('gateFilterList data res aaaa', res)
            setLoading(false)
            setGateList(res.data.data.content)
        }).catch((error)=> {
            setLoading(false)
            console.log('gateFilterList data err errrr', error)
            const errorMessage = error?.response?.data?.error || error.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    
    return{gateFilterList, gateList, loading}

}
